import { db } from "../firebase/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  updateDoc,
  doc
} from "firebase/firestore";

export async function recalculateAllBalances() {
  try {
    console.log("🔄 Recalculating account balances...");

    const accountsSnap = await getDocs(collection(db, "accounts"));

    for (const acc of accountsSnap.docs) {
      const accountId = acc.id;
      const account = acc.data();

      const openingBalance = Number(account.openingBalance || 0);

      // Fetch all transactions for this account
      const txSnap = await getDocs(
        query(
          collection(db, "transactions"),
          where("accountId", "==", accountId),
          orderBy("date", "asc")
        )
      );

      let balance = openingBalance;

      if (!txSnap.empty) {
        txSnap.forEach((t) => {
          const d = t.data();
          balance += (Number(d.amountIn) || 0) - (Number(d.amountOut) || 0);
        });
      }

      console.log(`✅ Updating ${account.name} to ${balance}`);

      await updateDoc(doc(db, "accounts", accountId), {
        currentBalance: balance,
      });
    }

    alert("✅ Balance Recalculation Complete");
  } catch (error) {
    console.error("❌ Error recalculating balances:", error);
    alert(error.message);
  }
}
